(function($) {
    const supercards = $('.js-supercard-offer');

    if (!supercards.length) {
        return;
    }

    // Hidden Form Elements
    const hiddenFormContainer = $('#hidden-form');

    // Add a close button to the hidden form
    const closeButton = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
    const closeButtonPath = document.createElementNS('http://www.w3.org/2000/svg', 'path');

    closeButton.setAttributeNS(null, 'class', 'svg-icon icon-cross close-form-icon');
    closeButton.setAttributeNS(null, 'width', 25);
    closeButton.setAttributeNS(null, 'height', 25);
    closeButton.setAttributeNS(null, 'aria-hidden', true);
    closeButton.setAttributeNS(null, 'viewBox', '0 0 32 32');

    closeButtonPath.setAttributeNS(null, 'd', 'M31.708 25.708c-0-0-0-0-0-0l-9.708-9.708 9.708-9.708c0-0 0-0 0-0 0.105-0.105 0.18-0.227 0.229-0.357 0.133-0.356 0.057-0.771-0.229-1.057l-4.586-4.586c-0.286-0.286-0.702-0.361-1.057-0.229-0.13 0.048-0.252 0.124-0.357 0.228 0 0-0 0-0 0l-9.708 9.708-9.708-9.708c-0-0-0-0-0-0-0.105-0.104-0.227-0.18-0.357-0.228-0.356-0.133-0.771-0.057-1.057 0.229l-4.586 4.586c-0.286 0.286-0.361 0.702-0.229 1.057 0.049 0.13 0.124 0.252 0.229 0.357 0 0 0 0 0 0l9.708 9.708-9.708 9.708c-0 0-0 0-0 0-0.104 0.105-0.18 0.227-0.229 0.357-0.133 0.355-0.057 0.771 0.229 1.057l4.586 4.586c0.286 0.286 0.702 0.361 1.057 0.229 0.13-0.049 0.252-0.124 0.357-0.229 0-0 0-0 0-0l9.708-9.708 9.708 9.708c0 0 0 0 0 0 0.105 0.105 0.227 0.18 0.357 0.229 0.356 0.133 0.771 0.057 1.057-0.229l4.586-4.586c0.286-0.286 0.362-0.702 0.229-1.057-0.049-0.13-0.124-0.252-0.229-0.357z');

    closeButton.append(closeButtonPath);

    // Add a title showing the offer type
    const formTitle = $('<h2 />', {'class': 'form-title', text: 'Angebot'});


    supercards.click(function(e) {
        
        e.preventDefault();

        let hiddenForm = hiddenFormContainer.find('form');
        let hiddenFormTypeField = hiddenFormContainer.find('#hidden-1');
        let hiddenFormType = $(this).data('offer-type');
        
        if (!hiddenFormContainer.hasClass('show-form')) {
            hiddenFormTypeField.val(hiddenFormType);
            formTitle.text('Angebot anfordern (' + hiddenFormType + ')');

            hiddenFormContainer.addClass('show-form');
            $('body').addClass('showing-hidden-form');
        }

        if (!hiddenFormContainer.hasClass('was-clicked')) {
            hiddenForm.prepend(formTitle);
            hiddenForm.prepend(closeButton);
            hiddenFormContainer.addClass('was-clicked');
        }

    });

    $(closeButton).click(function(e) {
        if (hiddenFormContainer.hasClass('show-form')) {
            hiddenFormContainer.removeClass('show-form');
            $('body').removeClass('showing-hidden-form');
        }
    });

})(jQuery);